import { render, staticRenderFns } from "./registeredAddress.vue?vue&type=template&id=421ee225"
import script from "./registeredAddress.vue?vue&type=script&lang=js"
export * from "./registeredAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports